import React from 'react';
const PopupInner = ({ innerRef, ...props }) => (React.createElement("div", Object.assign({}, props, { ref: innerRef })));
export default PopupInner;
